// Auto-enregistre tous les .vue de ce dossier comme composants globaux
export function registerAllIcons(app) {
  const ctx = require.context('./', false, /\.vue$/) // pas de sous-dossiers
  ctx.keys().forEach(k => {
    const comp = ctx(k).default
    const name = k.replace('./', '').replace('.vue', '') // "ArrowUp"
    app.component(name, comp)
  })
}
